module.exports = __webpack_public_path__ + "img/rightthigh.4e30fc71.svg";